// v2/pages/QuoteDetailV2.js — Teklif detayi: ozet, kalemler, PDF/Excel, sepete aktarim, siparis
// URL: /v2/quotes/:no?status=&q=&page=&per=
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  ArrowLeft, FileText, FileSpreadsheet, ShoppingCart, Send, RotateCw, Search, X,
  ChevronLeft, ChevronRight, Loader2, AlertTriangle, Info, Clock, Inbox, XCircle, Warehouse,
} from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ToastStack from '../components/Toast';
import {
  Acilir, OzetKartlari, Tutarlar, Uyarilar, KalemSatiri, AKTARILABILIR,
} from '../components/QuoteParts';
import useToast from '../hooks/useToast';
import useMenuNav from '../hooks/useMenuNav';
import useCartContext from '../hooks/CartContext';
import useExchangeRates from '../hooks/useExchangeRates';
import {
  useQuote, useQuoteLines, quoteApi, QUOTE_STATUS, LINE_STATUS, LINE_STATUS_ORDER,
  fmtTarih, kalanGun, fmtEur,
} from '../hooks/useQuotes';
import { formatTRY, formatNumber } from '../utils/format';
import styles from '../styles/DashboardV2.module.css';
import css from '../styles/QuotesV2.module.css';
import '../styles/tokens.css';

const PER_PAGE = [50, 100, 200];
const FILTRELER = ['all', ...LINE_STATUS_ORDER, 'kalkti'];

function sepetiYenile(cart) {
  if (!cart) return;
  const f = cart.yenile || cart.refresh || cart.reload;
  if (typeof f === 'function') f();
}

// ---------------------------------------------------------------- aktarim penceresi
function AktarimModal({ no, lineIds, mod, onKapat, onBitti }) {
  const [onizleme, setOnizleme] = useState(null);
  const [hata, setHata] = useState(null);
  const [mesgul, setMesgul] = useState(false);
  const [not, setNot] = useState(`Teklif ${no}`);
  const [siparis, setSiparis] = useState(mod === 'order');

  useEffect(() => {
    let iptal = false;
    quoteApi.toCart(no, lineIds, true)
      .then((v) => { if (!iptal) setOnizleme(v); })
      .catch((e) => { if (!iptal) setHata(e.message || 'Önizleme alınamadı'); });
    return () => { iptal = true; };
  }, [no, lineIds]);

  useEffect(() => {
    const esc = (e) => { if (e.key === 'Escape' && !mesgul) onKapat(); };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [mesgul, onKapat]);

  const onayla = async () => {
    setMesgul(true);
    setHata(null);
    let aktarim;
    try {
      aktarim = await quoteApi.toCart(no, lineIds, false);
    } catch (e) {
      setHata(e.message || 'Sepete aktarım yapılamadı');
      setMesgul(false);
      return;
    }
    if (!siparis) {
      onBitti({ tur: 'sepet', aktarim });
      return;
    }
    try {
      const sip = await quoteApi.createOrder(aktarim.itemIds, (not || '').trim().slice(0, 500));
      try { await quoteApi.ordered(no, aktarim.itemIds); } catch (e) { /* isaret kritik degil */ }
      onBitti({ tur: 'siparis', aktarim, siparis: sip });
    } catch (e) {
      onBitti({ tur: 'sepet', aktarim, siparisHatasi: e.message || 'Sipariş oluşturulamadı' });
    }
  };

  const s = onizleme && onizleme.summary;
  const fark = (onizleme && onizleme.priceChanges) || [];
  const eksik = (onizleme && onizleme.shortfalls) || [];
  const atlanan = (onizleme && onizleme.skipped) || [];

  return (
    <div className={css.modalBack} role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget && !mesgul) onKapat(); }}>
      <div className={css.modal} role="dialog" aria-modal="true" aria-labelledby="aktarim-baslik">
        <div className={css.modalHead}>
          <h2 id="aktarim-baslik" className={css.modalTitle}>
            {siparis ? <Send size={18} /> : <ShoppingCart size={18} />}
            {siparis ? 'Teklifi Siparişe Dönüştür' : 'Teklifi Sepete Aktar'}
          </h2>
          <button type="button" className={css.iconBtn} onClick={onKapat} disabled={mesgul} aria-label="Kapat">
            <X size={16} />
          </button>
        </div>

        <div className={css.modalBody}>
          {!onizleme && !hata && (
            <div className={css.modalLoading}><Loader2 size={22} className={css.spin} /> Güncel stok ve fiyatlar kontrol ediliyor…</div>
          )}
          {hata && <div className={css.alertRed} role="alert"><XCircle size={14} />{hata}</div>}

          {s && (
            <>
              <div className={css.pvGrid}>
                <span className={css.pvItem}><span>Ürün</span><b>{formatNumber(s.products)}</b></span>
                <span className={css.pvItem}><span>Toplam adet</span><b>{formatNumber(s.qty)}</b></span>
                <span className={css.pvItem}><span><Warehouse size={12} /> Gaziantep</span><b>{formatNumber(s.gzt)}</b></span>
                <span className={css.pvItem}><span><Warehouse size={12} /> İstanbul</span><b>{formatNumber(s.ist)}</b></span>
                <span className={`${css.pvItem} ${css.pvWide}`}><span>Net tutar (güncel fiyat, KDV hariç)</span><b>{formatTRY(s.net)}{s.euroRate ? <span className={css.eurInline}>{fmtEur(s.net / s.euroRate)}</span> : null}</b></span>
              </div>
              <p className={css.pvNote}>
                <Info size={13} /> Ürünler önce Gaziantep, kalan miktar İstanbul deposundan ayrılır.
                Fiyatlar güncel kur ve kampanyalarla yeniden hesaplanmıştır.
                {s.merged > 0 && ` ${formatNumber(s.merged)} ürün sepetinizde zaten olduğu için mevcut satıra eklenecek.`}
              </p>

              {fark.length > 0 && (
                <details className={css.pvBox} open={fark.length <= 5}>
                  <summary><AlertTriangle size={13} /> {formatNumber(fark.length)} üründe fiyat teklif tarihinden farklı</summary>
                  <div className={css.pvList}>
                    {fark.slice(0, 100).map((p) => (
                      <span key={p.code} className={css.pvRow}>
                        <b>{p.code}</b><span className={css.pvName}>{p.name}</span>
                        <span className={css.muted}>{formatTRY(p.quoteNet)}</span>→
                        <span className={p.diff > 0 ? css.red : css.green}>{formatTRY(p.currentNet)}</span>
                      </span>
                    ))}
                  </div>
                </details>
              )}
              {eksik.length > 0 && (
                <details className={css.pvBox}>
                  <summary><Info size={13} /> {formatNumber(eksik.length)} üründe talebin bir kısmı karşılanabiliyor</summary>
                  <div className={css.pvList}>
                    {eksik.slice(0, 100).map((p) => (
                      <span key={p.code} className={css.pvRow}>
                        <b>{p.code}</b><span className={css.pvName}>{p.name}</span>
                        <span>{formatNumber(p.supplied)} / {formatNumber(p.requested)} adet</span>
                      </span>
                    ))}
                  </div>
                </details>
              )}
              {atlanan.length > 0 && (
                <details className={css.pvBox}>
                  <summary><XCircle size={13} /> {formatNumber(atlanan.length)} ürün aktarılamayacak</summary>
                  <div className={css.pvList}>
                    {atlanan.slice(0, 100).map((p) => (
                      <span key={p.code} className={css.pvRow}>
                        <b>{p.code}</b><span className={css.pvName}>{p.name || ''}</span>
                        <span className={css.red}>{p.message}</span>
                      </span>
                    ))}
                  </div>
                </details>
              )}

              <label className={css.orderToggle}>
                <input type="checkbox" checked={siparis} disabled={mesgul}
                       onChange={(e) => setSiparis(e.target.checked)} />
                Sepete aktardıktan sonra siparişi hemen oluştur
              </label>
              {siparis && (
                <label className={css.noteLabel}>
                  Sipariş notu
                  <textarea className={css.note} rows={2} maxLength={500} value={not}
                            disabled={mesgul} onChange={(e) => setNot(e.target.value)} />
                </label>
              )}
            </>
          )}
        </div>

        <div className={css.modalFoot}>
          <button type="button" className={css.btnGhost} onClick={onKapat} disabled={mesgul}>Vazgeç</button>
          <button type="button" className={css.btnPrimary} onClick={onayla}
                  disabled={mesgul || !s || s.products === 0}>
            {mesgul ? <Loader2 size={15} className={css.spin} /> : (siparis ? <Send size={15} /> : <ShoppingCart size={15} />)}
            {siparis ? 'Sepete Aktar ve Sipariş Ver' : 'Sepete Aktar'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------- sayfa
export default function QuoteDetailV2() {
  const { no } = useParams();
  const navigate = useNavigate();
  const [sp, setSp] = useSearchParams();
  const [headerTerm, setHeaderTerm] = useState('');
  const cart = useCartContext();
  const toast = useToast();
  const kurlar = useExchangeRates();
  const handleMenu = useMenuNav(toast.push);

  const [durum, setDurum] = useState(() => (FILTRELER.includes(sp.get('status')) ? sp.get('status') : 'all'));
  const [ara, setAra] = useState(sp.get('q') || '');
  const [araGecikmeli, setAraGecikmeli] = useState(ara);
  const [page, setPage] = useState(() => Math.max(parseInt(sp.get('page'), 10) || 1, 1));
  const [per, setPer] = useState(() => (PER_PAGE.includes(Number(sp.get('per'))) ? Number(sp.get('per')) : PER_PAGE[0]));
  const [secim, setSecim] = useState(() => new Set());
  const [modal, setModal] = useState(null);       // {mod: 'cart'|'order', lineIds}
  const [indiriliyor, setIndiriliyor] = useState(null);
  const [cozumleniyor, setCozumleniyor] = useState(null);
  const [yenileniyor, setYenileniyor] = useState(false);
  const tabloRef = useRef(null);

  const teklif = useQuote(no);
  const q = teklif.quote;
  const kalemler = useQuoteLines(no, { status: durum, q: araGecikmeli, page, per });

  useEffect(() => {
    const t = setTimeout(() => { setAraGecikmeli(ara.trim()); setPage(1); }, 350);
    return () => clearTimeout(t);
  }, [ara]);

  useEffect(() => {
    const p = new URLSearchParams();
    if (durum !== 'all') p.set('status', durum);
    if (araGecikmeli) p.set('q', araGecikmeli);
    if (page > 1) p.set('page', String(page));
    if (per !== PER_PAGE[0]) p.set('per', String(per));
    if (p.toString() !== sp.toString()) setSp(p, { replace: true });
  }, [durum, araGecikmeli, page, per, sp, setSp]);

  const suresiDoldu = Boolean(q && q.expired);
  const kalan = q ? kalanGun(q.validUntil) : null;
  const st = q ? (QUOTE_STATUS[q.status] || QUOTE_STATUS['Hazır']) : null;
  const aktarilabilirSayi = q ? ((q.counts && q.counts.tam) || 0) + ((q.counts && q.counts.kismi) || 0) : 0;

  const sayfaSecilebilir = useMemo(
    () => kalemler.lines.filter((l) => AKTARILABILIR.includes(l.status) && !l.transferred).map((l) => l.id),
    [kalemler.lines]);
  const sayfaTumSecili = sayfaSecilebilir.length > 0 && sayfaSecilebilir.every((id) => secim.has(id));

  const filtreSec = useCallback((id) => {
    setDurum(id);
    setPage(1);
    if (tabloRef.current) tabloRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  const secimDegis = useCallback((id) => {
    setSecim((s) => {
      const n = new Set(s);
      if (n.has(id)) n.delete(id); else n.add(id);
      return n;
    });
  }, []);

  const sayfayiSec = () => {
    setSecim((s) => {
      const n = new Set(s);
      if (sayfaTumSecili) sayfaSecilebilir.forEach((id) => n.delete(id));
      else sayfaSecilebilir.forEach((id) => n.add(id));
      return n;
    });
  };

  const indir = async (tur, scope) => {
    setIndiriliyor(tur);
    if (q && q.lineCount > 3000) {
      toast.push('Büyük tekliflerde dosyanın hazırlanması 30 saniyeye kadar sürebilir', 'info');
    }
    try {
      await quoteApi.download(no, tur, scope);
    } catch (e) {
      toast.push(e.message || 'Dosya indirilemedi', 'error');
    } finally {
      setIndiriliyor(null);
    }
  };

  const cozumle = async (l, kod) => {
    setCozumleniyor(`${l.id}:${kod}`);
    try {
      const v = await quoteApi.resolve(no, l.id, kod);
      kalemler.kalemGuncelle(v.line);
      teklif.setQuote((eski) => ({ ...eski, ...v.quote, warnings: eski ? eski.warnings : [] }));
      toast.push(`${kod} seçildi`, 'success');
    } catch (e) {
      toast.push(e.message || 'Kalem güncellenemedi', 'error');
    } finally {
      setCozumleniyor(null);
    }
  };

  const yenile = async () => {
    setYenileniyor(true);
    try {
      const v = await quoteApi.renew(no);
      toast.push(`Güncel fiyatlarla ${v.quote.no} oluşturuldu`, 'success');
      setSecim(new Set());
      navigate(`/v2/quotes/${v.quote.no}`);
    } catch (e) {
      toast.push(e.message || 'Teklif yenilenemedi', 'error');
    } finally {
      setYenileniyor(false);
    }
  };

  const aktarimBitti = ({ tur, aktarim, siparisHatasi }) => {
    setModal(null);
    setSecim(new Set());
    kalemler.yenile();
    teklif.yenile();
    sepetiYenile(cart);
    if (tur === 'siparis') {
      toast.push(`Siparişiniz oluşturuldu (${formatNumber(aktarim.summary.products)} ürün)`, 'success');
      navigate('/v2/orders');
      return;
    }
    if (siparisHatasi) {
      toast.push(`Ürünler sepete aktarıldı ancak sipariş oluşturulamadı: ${siparisHatasi}. Sepetinizden sipariş verebilirsiniz.`, 'error');
      return;
    }
    toast.push(aktarim.message || 'Ürünler sepete aktarıldı', 'success');
  };

  const aktar = (mod) => setModal({ mod, lineIds: secim.size ? Array.from(secim) : null });

  if (teklif.loading) {
    return (
      <div className={styles.page}>
        <Header searchTerm={headerTerm} onSearchChange={setHeaderTerm} cart={cart}
                eurRate={kurlar.eurRate} onMenuSelect={handleMenu} />
        <main className={styles.main}>
          <div className={css.skelList}>{[0, 1, 2].map((i) => <div key={i} className={css.skel} />)}</div>
        </main>
      </div>
    );
  }

  if (teklif.error || !q) {
    return (
      <div className={styles.page}>
        <Header searchTerm={headerTerm} onSearchChange={setHeaderTerm} cart={cart}
                eurRate={kurlar.eurRate} onMenuSelect={handleMenu} />
        <main className={styles.main}>
          <div className={css.empty}>
            <Inbox size={34} strokeWidth={1.3} />
            <span>{teklif.error || 'Teklif bulunamadı'}</span>
            <Link to="/v2/quotes" className={css.btnGhost}><ArrowLeft size={14} /> Tekliflerime dön</Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <ToastStack items={toast.items} onDismiss={toast.dismiss} />
      <Header searchTerm={headerTerm} onSearchChange={setHeaderTerm} cart={cart}
              eurRate={kurlar.eurRate} onMenuSelect={handleMenu} />

      <main className={styles.main}>
        <div className={css.head}>
          <h1 className={css.title}>
            <Link to="/v2/quotes" className={css.back} aria-label="Tekliflerim"><ArrowLeft size={18} /></Link>
            Teklif {q.no}
            <span className={`${css.pill} ${css[st.tone]}`}>{st.label}</span>
            <span className={css.titleSub}>
              {fmtTarih(q.createdAt)}{q.fileName ? ` · ${q.fileName}` : ''}
              {q.note ? ` · “${q.note}”` : ''}
            </span>
          </h1>
          <span className={css.headActions}>
            <Acilir etiket="PDF" Icon={FileText} mesgul={indiriliyor === 'pdf'}
                    onSec={(s) => indir('pdf', s)}
                    secenekler={[{ id: 'all', label: 'Tüm kalemler' },
                                 { id: 'supplied', label: 'Yalnızca karşılanabilenler', hint: 'Tamamı + Kısmen' }]} />
            <Acilir etiket="Excel" Icon={FileSpreadsheet} mesgul={indiriliyor === 'excel'}
                    onSec={(s) => indir('excel', s)}
                    secenekler={[{ id: 'all', label: 'Tüm kalemler' },
                                 { id: 'supplied', label: 'Yalnızca karşılanabilenler', hint: 'Tamamı + Kısmen' }]} />
          </span>
        </div>

        <div className={`${css.validBar} ${suresiDoldu ? css.validExpired : ''}`}>
          <Clock size={15} />
          {suresiDoldu ? (
            <>
              <span>Bu teklifin geçerlilik süresi <b>{fmtTarih(q.validUntil, false)}</b> tarihinde doldu.</span>
              <span className={css.spacer} />
              <button type="button" className={css.btnPrimary} onClick={yenile} disabled={yenileniyor}>
                {yenileniyor ? <Loader2 size={14} className={css.spin} /> : <RotateCw size={14} />}
                Güncel Fiyatla Yenile
              </button>
            </>
          ) : (
            <>
              <span>
                Geçerlilik: <b>{fmtTarih(q.validUntil, false)}</b>
                {kalan !== null && <span className={css.daysLeft}>{kalan <= 0 ? 'bugün bitiyor' : `${kalan} gün kaldı`}</span>}
              </span>
              <span className={css.validInfo}>
                1 € = {formatNumber(q.euroRate, 4)} ₺ · Fiyatlar carinize özel indirimlerle hesaplandı;
                sipariş anında güncel fiyat uygulanır.
              </span>
            </>
          )}
        </div>

        <OzetKartlari q={q} aktif={durum} onSec={filtreSec} />
        <Tutarlar q={q} />
        <Uyarilar q={q} />

        <section className={css.card} ref={tabloRef}>
          <div className={css.toolbar}>
            <span className={css.searchBox}>
              <Search size={14} className={css.searchIcon} />
              <input className={css.searchInput} value={ara} onChange={(e) => setAra(e.target.value)}
                     placeholder="Kod, ürün adı veya stok kodunuz…" aria-label="Kalemlerde ara" />
              {ara && (
                <button type="button" className={css.searchClear} onClick={() => setAra('')} aria-label="Aramayı temizle">
                  <X size={12} />
                </button>
              )}
            </span>
            <span className={css.tabs} role="tablist">
              {FILTRELER.map((id) => {
                const etiket = id === 'all' ? 'Tümü' : id === 'kalkti' ? 'Kalkan' : LINE_STATUS[id].short;
                const n = id === 'all' ? q.lineCount : ((q.counts && q.counts[id]) || 0);
                if (id === 'kalkti' && !n) return null;
                return (
                  <button key={id} type="button" role="tab" aria-selected={durum === id}
                          className={`${css.tab} ${durum === id ? css.tabOn : ''}`}
                          onClick={() => filtreSec(id)}>
                    {etiket}<span className={css.tabCount}>{formatNumber(n)}</span>
                  </button>
                );
              })}
            </span>
          </div>

          {kalemler.error && (
            <div className={css.alertRed}>
              {kalemler.error}
              <button type="button" className={css.linkBtn} onClick={kalemler.yenile}><RotateCw size={12} /> Tekrar dene</button>
            </div>
          )}

          {kalemler.loading ? (
            <div className={css.skelList}>{[0, 1, 2, 3].map((i) => <div key={i} className={css.skel} />)}</div>
          ) : kalemler.lines.length === 0 ? (
            <div className={css.empty}>
              <Inbox size={30} strokeWidth={1.3} />
              <span>Bu filtrede kalem bulunmuyor.</span>
            </div>
          ) : (
            <div className={`${css.tableScroll} ${kalemler.refreshing ? css.fading : ''}`}>
              <table className={`${css.table} ${css.lTable}`}>
                <thead>
                  <tr>
                    <th className={css.cCheck}>
                      <input type="checkbox" checked={sayfaTumSecili} disabled={!sayfaSecilebilir.length || suresiDoldu}
                             onChange={sayfayiSec} aria-label="Bu sayfadaki aktarılabilir kalemleri seç" />
                    </th>
                    <th aria-label="Görsel" />
                    <th>Ürün Kodu</th>
                    <th>Ürün Açıklaması</th>
                    <th className={css.right}>Talep</th>
                    <th>Karşılanan</th>
                    <th>Durum</th>
                    <th>Depo</th>
                    <th className={css.right}>Birim Brüt</th>
                    <th className={css.center}>İndirim</th>
                    <th className={css.right}>Birim Net</th>
                    <th className={css.right}>Toplam Tutar</th>
                  </tr>
                </thead>
                <tbody>
                  {kalemler.lines.map((l) => (
                    <KalemSatiri key={l.id} l={l} secili={secim.has(l.id)} onSecim={secimDegis}
                                 onCozumle={cozumle} cozumleniyor={cozumleniyor} kilitli={suresiDoldu} />
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {kalemler.totalItems > 0 && (
            <div className={css.pager}>
              <span className={css.pagerInfo}>
                <b>{formatNumber(kalemler.totalItems)}</b> kalem · Sayfa {page}/{kalemler.totalPages}
              </span>
              <label className={css.perLabel}>
                Sayfa başına
                <select className={css.select} value={per}
                        onChange={(e) => { setPer(Number(e.target.value)); setPage(1); }}>
                  {PER_PAGE.map((n) => <option key={n} value={n}>{n}</option>)}
                </select>
              </label>
              <span className={css.spacer} />
              <button type="button" className={css.pageBtn} disabled={page <= 1}
                      onClick={() => setPage((p) => p - 1)} aria-label="Önceki sayfa">
                <ChevronLeft size={15} />
              </button>
              <button type="button" className={css.pageBtn} disabled={page >= kalemler.totalPages}
                      onClick={() => setPage((p) => p + 1)} aria-label="Sonraki sayfa">
                <ChevronRight size={15} />
              </button>
            </div>
          )}
        </section>
      </main>

      {!suresiDoldu && aktarilabilirSayi > 0 && (
        <div className={css.actionBar}>
          <span className={css.actionInfo}>
            {secim.size > 0
              ? <><b>{formatNumber(secim.size)}</b> kalem seçildi
                  <button type="button" className={css.linkBtn} onClick={() => setSecim(new Set())}>Seçimi temizle</button></>
              : <>Seçim yapılmadı: stokta olan <b>tüm kalemler</b> aktarılır</>}
          </span>
          <span className={css.spacer} />
          <button type="button" className={css.btnGhost} onClick={() => aktar('cart')}>
            <ShoppingCart size={15} /> {secim.size ? 'Seçilenleri Sepete Aktar' : 'Tümünü Sepete Aktar'}
          </button>
          <button type="button" className={css.btnPrimary} onClick={() => aktar('order')}>
            <Send size={15} /> Doğrudan Sipariş Ver
          </button>
        </div>
      )}

      {modal && (
        <AktarimModal no={q.no} lineIds={modal.lineIds} mod={modal.mod}
                      onKapat={() => setModal(null)} onBitti={aktarimBitti} />
      )}
      <Footer />
    </div>
  );
}
